import React from 'react'
import "./Pink_box.css"

function Pink_box({box_text, desc_text}) {
  return (
    <>
    <section className='Pink_box'>
      <div>
        <h4>{box_text}</h4>
        <p>{desc_text}</p>
      </div>
    </section>
    </>
  )
}

export default Pink_box